module.exports = __webpack_public_path__ + "static/media/ITA.f9290ea1.svg";